import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWallet = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 25'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='wallet_svg__a'
      width={20}
      height={19}
      x={2}
      y={3}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill='#000' d='M16.5 14.5q1.5 0 1.5-1.5t-1.5-1.5T15 13t1.5 1.5' />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M2 6.5a3 3 0 0 1 3-3h8.764a3 3 0 0 1 2.683 1.658L17.618 7.5H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm15.022 3H5c-.35 0-.687-.06-1-.17v9.17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-2.364-3.447.724 1.447H5a1 1 0 0 1 0-2h8.764a1 1 0 0 1 .894.553'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#wallet_svg__a)'>
      <path fill={props.color} d='M0 .5h24v24H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgWallet)
export default ForwardRef
